import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

type Theme = 'dark' | 'light' | 'system'

export const useThemeStore = defineStore('theme', () => {
  const theme = ref<Theme>('dark')
  const isDark = ref(true)

  function initTheme() {
    const savedTheme = localStorage.getItem('xdns_theme') as Theme | null
    
    if (savedTheme) {
      setTheme(savedTheme)
    } else {
      setTheme('dark')
    }
  }

  function setTheme(newTheme: Theme) {
    theme.value = newTheme
    localStorage.setItem('xdns_theme', newTheme)
    
    if (newTheme === 'system') {
      isDark.value = window.matchMedia('(prefers-color-scheme: dark)').matches
    } else {
      isDark.value = newTheme === 'dark'
    }
    
    updateDocumentClass()
  }

  function toggleTheme() {
    setTheme(isDark.value ? 'light' : 'dark')
  }

  function updateDocumentClass() {
    if (isDark.value) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }

  // Listen for system theme changes
  if (typeof window !== 'undefined') {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
      if (theme.value === 'system') {
        isDark.value = e.matches
        updateDocumentClass()
      }
    })
  }

  watch(isDark, updateDocumentClass)

  return {
    theme,
    isDark,
    initTheme,
    setTheme,
    toggleTheme,
  }
})
